import React, { useState } from "react";

const Page9 = () => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div style={{paddingTop: '100px'}}>
      <div
        className="col-md-12 fontS-18"
        style={{ marginBottom: 40, paddingBottom: 5 }}
      >
        <p>
          Esse exemplo do <strong>vazamento de cloro</strong> deixa claro que mudanças não avaliadas corretamente podem comprometer a segurança, o meio ambiente e a continuidade da operação. 
        </p>

        <p>Mesmo quando o objetivo é resolver um problema, decisões sem análise estruturada aumentam os riscos.</p>
      </div>


      {/* Caixa de destaque */}
      <div
        style={{
          backgroundColor: "#e9ffcd",
          borderLeft: "6px solid #89D127",
          padding: "25px",
          borderRadius: "6px",
          color: "#0f8504",
          fontSize: "18px",
          lineHeight: "1.6",
          marginBottom: 40,
        }}
      >
        <p>Então, surge uma pergunta essencial: como garantir que as mudanças sejam tratadas de forma segura e consistente?</p>
      </div>

      <div className="col-md-12 fontS-18" style={{ marginBottom: 40, paddingBottom: 5 }}
      >
        <p>
          Para responder a isso, é preciso entender quais são as bases legais, corporativas e de segurança que sustentam o MOC e orientam sua aplicação na prática. 
        </p>

      </div>
    </div>
  );
};

export default Page9;